import { createApi } from '@reduxjs/toolkit/query/react';

import {
  GetReportExportsInput,
  LaunchReportExportInput,
  ReportExport,
  ReportExportsResponse,
} from '@/slices/report-exports/reportExports.types';

import { symfonyBaseQuery } from '@/services/SymfonyClient';

const reportExportsApi = createApi({
  baseQuery: symfonyBaseQuery({
    baseUrl: '/api/enterprises',
  }),
  reducerPath: 'reportExports',
  tagTypes: ['ReportExports'],
  invalidationBehavior: 'delayed',
  endpoints: (build) => ({
    getReportExports: build.query<ReportExport[], GetReportExportsInput>({
      query: ({ enterpriseId }) => ({
        url: `/${enterpriseId}/report-exports`,
        method: 'GET',
      }),
      transformResponse: (response: ReportExportsResponse) =>
        response.reportExports ?? [],
      providesTags: (_result, _error, { enterpriseId }) => [
        { type: 'ReportExports', id: enterpriseId },
      ],
    }),
    launchReportExport: build.mutation<ReportExport, LaunchReportExportInput>({
      query: ({ enterpriseId, reportId }) => ({
        url: `/${enterpriseId}/reports/${reportId}/export`,
        method: 'GET',
      }),
      invalidatesTags: (_result, error, { enterpriseId }) =>
        error ? [] : [{ type: 'ReportExports', id: enterpriseId }],
      async onQueryStarted({ enterpriseId }, { dispatch, queryFulfilled }) {
        try {
          const { data: reportExport } = await queryFulfilled;
          dispatch(
            reportExportsApi.util.updateQueryData(
              'getReportExports',
              { enterpriseId },
              (draft) => {
                const index = draft.findIndex(
                  ({ id }) => id === reportExport.id,
                );

                if (index >= 0) {
                  draft[index] = reportExport;
                } else {
                  draft.push(reportExport);
                }
              },
            ),
          );
        } catch {
          // Keep the cache unchanged when launching the export fails.
        }
      },
    }),
  }),
});

export default reportExportsApi;
